import { render } from "./Collapse.vue?vue&type=template&id=e771ffc2&ts=true"
import script from "./Collapse.vue?vue&type=script&lang=ts"
export * from "./Collapse.vue?vue&type=script&lang=ts"

import "./Collapse.vue?vue&type=style&index=0&id=e771ffc2&lang=css"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__